/**
 * Static-translations for he. Generated from:
 *  - `online/lang/static-translations.ts` (legacy, via KEY_MAP)
 *  - `tools/sdk-translations.mjs` (SDK-specific strings)
 *
 * Do not edit by hand — changes are lost on the next `node tools/gen-locales.mjs`.
 * To fix a translation, edit legacy/sdk-translations.mjs and regenerate.
 */
const he = {
  'anon.heading_default': 'המשך כאורח',
  'anon.try_again': 'נסה שוב',
  'auth.back_to_login': 'חזרה להתחברות',
  'auth.check_email_message': 'בדוק את הדואר שלך לקבלת קוד האישור.',
  'auth.check_email_title': 'בדוק את הדואר שלך',
  'auth.confirm_email_title': 'אימות הדואר האלקטרוני',
  'auth.confirmation_code': 'קוד אישור',
  'auth.continue_with_apple': 'המשך עם Apple',
  'auth.continue_with_facebook': 'המשך עם Facebook',
  'auth.continue_with_github': 'המשך עם GitHub',
  'auth.continue_with_google': 'המשך עם Google',
  'auth.create_account': 'צור חשבון',
  'auth.default_subtitle': 'התחבר כדי לגשת לכל התכונות ולסנכרן את הנתונים שלך.',
  'auth.email': 'כתובת אימייל',
  'auth.email_already_registered': 'הדוא"ל הזה כבר רשום. היכנס למטה עם הסיסמה שלך או החשבון שאיתו נרשמת.',
  'auth.email_exists': 'כבר קיים חשבון עם דוא"ל זה.',
  'auth.email_not_confirmed': 'אנא אשר תחילה את כתובת הדוא"ל שלך.',
  'auth.forgot_password': 'שכחת סיסמה?',
  'auth.forgot_password_title': 'שכחת סיסמה?',
  'auth.forgot_subtitle': 'הזן את האימייל שלך ונשלח לך קישור לאיפוס סיסמה.',
  'auth.generic_error': 'משהו השתבש',
  'auth.have_account': 'יש לך חשבון?',
  'auth.hide_password': 'הסתר סיסמה',
  'auth.identity_already_linked': 'החשבון הזה כבר רשום. היכנס איתו למטה.',
  'auth.invalid_credentials': 'דוא"ל או סיסמה שגויים',
  'auth.invalid_otp': 'הקוד אינו תקף או פג תוקפו.',
  'auth.last_used': 'בשימוש אחרון · {email}',
  'auth.last_used_no_email': 'בשימוש אחרון',
  'auth.link_purchase_subheading': 'נקשר את הרכישה לחשבון שלך כדי לשמור על הגישה.',
  'auth.log_in': 'התחבר',
  'auth.log_in_link': 'התחבר',
  'auth.login_continue_purchase': 'התחבר כדי להמשיך את הרכישה שלך',
  'auth.network_error': 'שגיאת רשת. בדוק את החיבור ונסה שוב.',
  'auth.no_account': 'אין לך חשבון?',
  'auth.or': 'או',
  'auth.password': 'סיסמה',
  'auth.passwords_mismatch': 'הסיסמאות אינן תואמות',
  'auth.rate_limited': 'יותר מדי בקשות. נסה שוב מאוחר יותר.',
  'auth.repeat_password': 'חזור על הסיסמה',
  'auth.reset_link_valid': 'הקישור בתוקף לשעה.',
  'auth.reset_password_title': 'איפוס סיסמה',
  'auth.reset_sent_message': 'אם הדואר קיים, נשלח קוד איפוס.',
  'auth.reset_sent_subtitle': 'שלחנו קישור לאיפוס סיסמה. עקוב אחר ההוראות במייל.',
  'auth.restore_purchases_heading': 'שחזר רכישות',
  'auth.restore_purchases_subheading': 'אנא התחבר כדי לשחזר את הרכישות שלך.',
  'auth.send_reset': 'שלח אימייל איפוס',
  'auth.service_unavailable': 'השירות אינו זמין כעת. נסה שוב מאוחר יותר.',
  'auth.show_password': 'הצג סיסמה',
  'auth.sign_out': 'התנתק',
  'auth.sign_up': 'הירשם',
  'auth.sign_up_link': 'הירשם',
  'auth.signed_in': 'מחובר',
  'auth.signin_failed': 'ההתחברות נכשלה',
  'auth.signup_failed': 'הרישום נכשל',
  'auth.verify': 'אמת',
  'auth.weak_password': 'הסיסמה חלשה מדי.',
  'auth.welcome': 'ברוך הבא!',
  'auth.welcome_signup': 'ברוך הבא!',
  'countdown.d': 'י',
  'countdown.h': 'ש',
  'countdown.m': 'דק',
  'countdown.s': 'שנ',
  'cta.close': 'סגור',
  'cta.continue': 'המשך',
  'cta.get_lifetime_access': 'קבל גישה לכל החיים',
  'cta.get_plan_daily': 'קבל תוכנית יומית',
  'cta.get_plan_monthly': 'קבל תוכנית חודשית',
  'cta.get_plan_weekly': 'קבל תוכנית שבועית',
  'cta.get_plan_yearly': 'קבל תוכנית שנתית',
  'cta.start_trial': 'התחל תקופת ניסיון חינם של {days} ימים',
  'modal.close_aria': 'סגור',
  'modal.continue': 'המשך',
  'modal.error_generic': 'משהו השתבש',
  'modal.loading': 'טוען…',
  'modal.purchase_restored_subtitle': 'הכול מוכן — תיהנו!',
  'modal.purchase_restored_title': 'ברוך שובך',
  'modal.purchase_success_subtitle': 'הכול מוכן — תיהנו!',
  'modal.purchase_success_title': 'התקבל תשלום',
  'modal.verifying_subscription': 'בודק את המינוי שלך…',
  'nav.back': '→ חזרה',
  'nav.back_aria': 'חזרה',
  'offer.limited_time': 'הצעה לזמן מוגבל',
  'payment.awaiting_title': 'השלם את התשלום בלשונית החדשה',
  'payment.checking': 'בודק…',
  'payment.ive_paid': 'שילמתי',
  'payment.open_checkout_again': 'פתח תשלום שוב',
  'payment.open_checkout_button': 'פתח תשלום',
  'pricing.free_trial_days': 'ניסיון חינם של {days} ימים',
  'pricing.included_per': 'כלול לכל {interval}:',
  'pricing.interval.day': 'יום',
  'pricing.interval.lifetime_short': 'לכל החיים',
  'pricing.interval.month': 'חודש',
  'pricing.interval.period': 'תקופה',
  'pricing.interval.week': 'שבוע',
  'pricing.interval.year': 'שנה',
  'pricing.money_back': 'אחריות החזר כספי ל-30 ימים',
  'pricing.most_popular': 'הכי פופולרי',
  'pricing.no_prices': 'אין מחירים זמינים.',
  'pricing.plan_label.daily': 'תוכנית יומית',
  'pricing.plan_label.lifetime': 'לכל החיים',
  'pricing.plan_label.monthly': 'תוכנית חודשית',
  'pricing.plan_label.weekly': 'תוכנית שבועית',
  'pricing.plan_label.yearly': 'תוכנית שנתית',
  'pricing.plans_aria': 'תוכניות',
  'session.contact_support': 'צור קשר עם התמיכה',
  'session.restore_purchases': 'שחזר רכישות',
  'session.sign_out': 'התנתק',
  'session.signed_in_as_prefix': 'מחובר בתור',
  'session.signing_out': 'מתנתק…',
  'support.attachments_label': 'קבצים מצורפים',
  'support.close_button': 'סגור',
  'support.done_button': 'בוצע',
  'support.email_placeholder': 'הזן את האימייל שלך',
  'support.heading': 'תמיכה',
  'support.instruction': 'אנא מלא את הטופס למטה כדי לשלוח את בקשת התמיכה שלך.',
  'support.invalid_email': 'אימייל לא תקין',
  'support.message_length': '1–5000 תווים',
  'support.message_placeholder': 'הזן את הודעתך',
  'support.required': 'נדרש',
  'support.send_another': 'שלח בקשה נוספת',
  'support.send_button': 'שלח',
  'support.sending': 'שולח…',
  'support.subject_length': '3–200 תווים',
  'support.subject_placeholder': 'הזן את הנושא שלך',
  'support.success_heading': 'הבקשה נשלחה',
  'support.success_message_prefix': 'קיבלנו את הודעתך ונגיב ל'
} as const;

export default he;
